import { useEffect } from 'react'

interface Props {
  src: string
  alt: string
  onClose: () => void
}

/** Full-size view of an item photo. Closes on Escape, backdrop click, or the button. */
export function ImageLightbox({ src, alt, onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onPointerDown={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <button type="button" className="lightbox-close" onClick={onClose} aria-label="Close photo">
        ✕
      </button>
      <img src={src} alt={alt} />
    </div>
  )
}
